import React, { useMemo, useState } from 'react';
import Input from '../ShareholderDetails/Input';
import { TDirectorInfo, TInfoltd } from '../../../types';
import UploadedDocs from '../ShareholderDetails/UploadedDocs';
import { cloud } from '../../../assets/images/dashboard-business';
import Button2 from '../../global/Button2';
import PreviewDocModal from '../ShareholderDetails/PreviewDocModal';
import DateInput from '../../global/DateInput';

type TProps = {
  shareholder: TDirectorInfo;
};
const ShareholderDetails = ({ shareholder }: TProps) => {
  const [showModal, setShowModal] = useState(false);
  const [doc, setDoc] = useState('');
  const docs = useMemo(() => {
    return {
      'PASSPORT PHOTOGRAPH': shareholder?.passport,
      'PROOF OF ADDRESS': shareholder?.proofOfAddress,
      'VALID ID CARD': shareholder?.idCard,
      'SIGNATURE SPECIMEN': shareholder?.signature,
    };
  }, [shareholder]);
  return (
    <div className='my-5'>
      <div className='text-[13px] font-[600] text-[#028789] mb-4'>Personal Details</div>
      <div className='sl:flex justify-between flex-wrap gap-[4%]'>
        <Input label={'First name'} value={shareholder?.firstName} style='sl:w-[30%]' readonly />

        <Input
          label={'Middle name '}
          value={shareholder?.middleName ?? ''}
          style='sl:w-[30%]'
          readonly
        />
        <Input label={'Last name'} value={shareholder?.lastName} style='sl:w-[30%]' readonly />
        <Input label={'Nationality'} value={shareholder?.nationality} style='sl:w-[30%]' readonly />
        <Input label={'Gender'} value={shareholder?.gender} style='sl:w-[30%]' readonly />
        <Input label={'Email'} value={shareholder?.email} style='sl:w-[30%]' readonly />
        <Input
          label={'National Identity Number(NIN)'}
          value={shareholder?.identityNumber}
          style='sl:w-[30%]'
          readonly
        />
        <Input label={'Phone number'} value={shareholder?.phone} style='sl:w-[30%]' readonly />
        {/* <Input label={'Date of birth'} value={shareholder?.birthDate} style='sl:w-[30%]' readonly /> */}
        {/* <div className='w-full sl:w-[30%]'>
          <DateInput
            className='!h-[52px] !border-[#B8C9C9] px-4'
            placeholderText='Date of Birth'
            value={shareholder?.birthDate?.split('T')[0]}
            labelStyles='!pb-[5px]'
            onChange={() => {
              return;
            }}
            disable
          />
        </div> */}
      </div>

      <div className='text-[13px] font-[600] text-[#028789] mt-4 mb-4'>Residential Address</div>

      <div className='sl:flex justify-between flex-wrap gap-[4%]'>
        <Input
          label={'Street Number and name'}
          value={shareholder?.streetNumber + ', ' + shareholder?.streetName}
          style='sl:w-[30%]'
          readonly
        />

        <Input
          label={'State'}
          value={shareholder?.locatedState ?? ''}
          style='sl:w-[30%]'
          readonly
        />
        <Input
          label={'Local Government Area'}
          value={shareholder?.lga}
          style='sl:w-[30%]'
          readonly
        />
        <Input label={'City or Town'} value={shareholder?.cityOrTown} style='sl:w-[30%]' readonly />
      </div>

      <div className='text-[13px] font-[600] text-[#028789] mb-4 mt-2'>Uploaded Documents</div>
      <table className='w-full'>
        <tbody className='mt-4'>
          {Object.keys(docs)?.map((docName, _) => (
            <tr key={_} className='text-xs border-2 border-[#CDD8EA] py-2 box-content'>
              <td>
                <div className='flex justify-between flex-wrap py-3 px-3'>
                  <div className='flex gap-2 items-center font-[500] text-[xs] md:text-[16px] mb-3 text-[#4F4F4F]'>
                    <img src={cloud} alt='' />
                    <div className='min-w-[200px]'>{docName}</div>
                  </div>

                  <div className='flex gap-2'>
                    <Button2
                      type='submit'
                      theme='tertiary'
                      className='!px-4 !gap-1 py-[6px] text-[11px] inline-block '
                      size='sm'
                      underline={false}
                      onClick={() => {
                        setDoc(docName);
                        setShowModal(true);
                      }}
                    >
                      PREVIEW
                    </Button2>
                  </div>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <PreviewDocModal title={doc} obj={docs} setShowModal={setShowModal} showModal={showModal} />
    </div>
  );
};

export default ShareholderDetails;
